import { setting } from "shared/types/Report";
import { SettingCard, SettingTitle, SettingGroupWrap, SettingGroup, SettingLabelWrap, SettingLabel, SettingCheck, SettingSelect } from "../homeworkUi";

interface VideoSettingProps {
    viewOptions: (name: string, max: number, unit: string) => any[],
    setting: setting
}

const VideoSettingViewer = ({ viewOptions, setting }: VideoSettingProps) => {
    return (
        <SettingCard>
            <SettingTitle>영상 학습</SettingTitle>
            <SettingGroupWrap>
                <SettingGroup>
                    <SettingLabelWrap>
                        <SettingCheck type="checkbox" id="video" name="video" checked={setting.video.video} disabled />
                        <SettingLabel htmlFor="video">녹음 하기</SettingLabel>
                    </SettingLabelWrap>
                    <SettingSelect name="video_repeat" value={setting.video.video_repeat} disabled>
                        {viewOptions("녹음 동영상 보기", 4, "번")}
                    </SettingSelect>
                </SettingGroup>
            </SettingGroupWrap>
        </SettingCard>
    )
}

export default VideoSettingViewer;
